import React from 'react';
import { useNavigate } from 'react-router-dom';
import MovdMarketingHero from '../design-system/MovdMarketingHero.jsx';
import MovdButton from '../design-system/MovdButton.jsx';
import { movdTokens } from '../design-system/movdTokens.js';

const services = [
  { icon: '\uD83C\uDFE0', title: 'Residential Moving', description: 'Complete home moving services for any size residence', features: ['Packing & Unpacking', 'Furniture Assembly', 'Appliance Moving', 'Piano Moving'] },
  { icon: '\uD83C\uDFE2', title: 'Commercial Moving', description: 'Office and business relocations with minimal downtime', features: ['Office Equipment', 'IT Setup', 'Weekend Moves', 'Document Handling'] },
  { icon: '\uD83D\uDE9A', title: 'Long Distance', description: 'Cross-province and cross-country moving services', features: ['Climate Control', 'Tracking Updates', 'Secure Storage', 'Insurance Coverage'] },
  { icon: '\uD83D\uDCE6', title: 'Storage Solutions', description: 'Short and long-term storage in secure facilities', features: ['Climate Controlled', '24/7 Security', 'Easy Access', 'Inventory Management'] },
  { icon: '\uD83D\uDCE6', title: 'Packing Services', description: 'Professional packing with premium materials', features: ['Fragile Item Packing', 'Custom Crating', 'Labeling System', 'Unpacking Service'] },
  { icon: '\u2705', title: 'Specialty Moving', description: 'Expert handling of valuable and delicate items', features: ['Artwork & Antiques', 'Wine Collections', 'Medical Equipment', 'Pool Tables'] },
];

export default function ServicesPage() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh' }}>
      <MovdMarketingHero eyebrow="What we offer" title="Our services" subtitle="Comprehensive moving solutions tailored to every need — from studio apartments to cross-country relocations." />
      <div style={{ maxWidth: 1120, margin: '0 auto', padding: 'clamp(24px, 5vw, 48px) 20px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 24, marginBottom: 40 }}>
          {services.map(service => (
            <div key={service.title} style={{ padding: 24, borderRadius: 12, boxShadow: movdTokens.shadow.raised, background: '#fff', display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                <span style={{ fontSize: 32 }} aria-hidden="true">{service.icon}</span>
                <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>{service.title}</h2>
              </div>
              <p style={{ margin: '0 0 12px', color: movdTokens.color.content.secondary, fontSize: 14, lineHeight: 1.5 }}>{service.description}</p>
              <ul style={{ margin: '0 0 16px', paddingLeft: 0, listStyle: 'none', display: 'grid', gap: 6, flexGrow: 1 }}>
                {service.features.map(feature => (
                  <li key={feature} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                    <span aria-hidden="true" style={{ color: movdTokens.color.state.success }}>✓</span>{feature}
                  </li>
                ))}
              </ul>
              <MovdButton variant="secondary" onClick={() => navigate('/')} style={{ width: '100%' }}>Get quote</MovdButton>
            </div>
          ))}
        </div>

        <div style={{ padding: 'clamp(24px, 5vw, 40px)', textAlign: 'center', borderRadius: 12, background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)', border: '1px solid #e2e8f0' }}>
          <h2 style={{ margin: '0 0 8px', fontWeight: 800, fontSize: 22 }}>Ready to get started?</h2>
          <p style={{ margin: '0 0 20px', color: movdTokens.color.content.secondary, maxWidth: 500, marginLeft: 'auto', marginRight: 'auto' }}>Get instant quotes from verified movers in your area and start planning your move today.</p>
          <MovdButton onClick={() => navigate('/')}>Get your free quote</MovdButton>
        </div>
      </div>
    </div>
  );
}
